<template>
  <div
    class="main scroll"
    @click="cancelContent"
    @contextmenu.prevent="contentRight($event)"
    ref="scroll"
  >
    <div class="scroll-wrapper">
      <div class="head-title">
        <div class="left">
          <div @click="$router.back()" class="name">班级相册</div>
          <div class="icon">></div>
          <div class="main blue">
            {{ albumName }}
          </div>
          <!-- <a-icon style="{color:#f1f8fd}" type="caret-down" /> -->
          <a-select
            v-if="albumName != '默认相册'"
            style="width:160px;margin-left:10px"
            v-model="type"
            size="small"
            @change="changeType"
          >
            <a-select-option key="" value="">全部照片</a-select-option>
            <a-select-option key="1" :value="1"
              >已识别未分配照片</a-select-option
            >
            <a-select-option key="2" :value="2"
              >未识别未分配照片</a-select-option
            >
          </a-select>
          <a-select
            v-else
            style="width:160px;margin-left:10px"
            v-model="img_type"
            size="small"
            @change="changeType2"
          >
            <a-select-option key="" value="">全部照片</a-select-option>
            <a-select-option key="1" value="pic"
              >照片</a-select-option
            >
            <a-select-option key="2" value="record"
              >音频</a-select-option
            >
            <a-select-option key="3" value="video"
              >视频</a-select-option
            >
          </a-select>
        </div>
        <div class="right">
          <div class="num">
            已上传照片<span class="blue">{{ photoNum }}</span>
          </div>
          <div class="msg">
            <div class="txt blue">相册信息</div>
            <a-icon :style="{color:'#898989'}" type="caret-down" />
          </div>
        </div>
      </div>
      <div class="content">
        <div v-if="!photoList" class="frame-list">
          <img
              
              @click="uploadModal = true"
              class="addframe"
              :src="require('@/assets/upload-03.png')"
              alt=""
            />
        </div>
        <div
          class="time-item"
          v-for="(item, time, timeIndex) in photoList"
          :key="timeIndex"
        >
          <div class="time">{{ time }}</div>
          <div class="frame-list">
            <img
              @click="uploadModal = true"
              v-if="timeIndex == 0 && albumName != '默认相册'"
              class="addframe"
              :src="require('@/assets/upload-03.png')"
              alt=""
            />
            <div
              @click="selectPhoto($event, index, timeIndex)"
              v-for="(photoitem, index) in item"
              :key="index"
              @dblclick="showBigPic(photoitem,index,timeIndex,time)"
              @contextmenu.prevent="photoRight($event, index, timeIndex)"
              class="cell"
              :class="photoitem && photoitem.select ? 'select' : ''"
              :style="{backgroundImage: photoitem.type == 'pic' || photoitem.type === null ? 'url('+photoitem.img_url+')' : photoitem.type == 'record' ? 'url('+ require('@/assets/director/record.png') +')' : 'none'}"
            >
              
              <video v-if="photoitem && photoitem.type == 'video'" disabled :autoplay="false" style="width: 100%;object-fit: fill;height:100%">
                <source :src="clearUrl(photoitem.img_url)" type="video/mp4" />
              </video>
              <div v-if="photoitem && photoitem.type == 'video'"  style="position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%);background: rgba(0, 0, 0, 0.1);border-radius: 5px;display: flex;flex-direction: column;align-items: center;justify-content: center;padding: 10px; width: 100px;">
                <a-icon style="color: #fff;font-size: 60px;" type="caret-right" />
                <div style="font-size: 12px;color: #fff;">双击预览播放</div>
              </div>

              <!-- <img class="photo" v-lazy="item.img_url" alt="" /> -->
              <div v-if="photoitem && photoitem.is_sb" class="tip">已识</div>
              <div v-if="photoitem && photoitem.binding_data" class="fp">
                <div
                  v-show="index2 < 5"
                  @click="delStudentBind(student.id, photoitem.id)"
                  v-for="(student, index2) in photoitem.binding_data"
                  :key="index2"
                  class="fp-cell"
                >
                  <div v-if="student" class="name" style="white-space:nowrap">{{ student.name }}</div>
                  <a-icon :style="{color:'#eeeeee'}" type="close-circle" />
                </div>
                <div @click="showSingleModal(index,timeIndex)" class="fp-cell">
                  <div class="blue">更多...</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="showRight"
        class="rightContent"
        ref="rightContent"
        :style="rightStyle"
      >
        <div v-if="albumName != '默认相册'" @click="uploadModal = true" class="cell">上传照片</div>
        <div @click="showDisModel" v-show="currentPhoto" class="cell">
          分配照片
        </div>
        <div v-if="albumName != '默认相册'" @click="handleSelectAll" class="cell">选择全部</div>
        <div v-if="albumName != '默认相册'" @click="delModal = true" class="cell">删除照片</div>
      </div>
      <a-modal :visible="editModal" centered :closable="false" footer="">
        <div class="modal3">
          <img :src="require('../assets/logo.png')" alt="" />
          <div class="msg">
            <div class="title">修改相册名称</div>
            <a-input
              v-if="currentPhoto"
              v-model="currentPhoto.name"
              :placeholder="currentPhoto ? currentPhoto.name : ''"
            />
            <div class="btns">
              <a-button @click="editModal = false">取消</a-button>
              <a-button @click="handleEditPhoto" type="primary">
                确认
              </a-button>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal :visible="delModal" centered :closable="false" footer="">
        <div class="modal3 red">
          <img :src="require('../assets/log2.png')" alt="" />
          <div class="msg">
            <div class="title">删除此相册所有照片，不可恢复。是否继续？</div>
            <div class="btns">
              <a-button @click="delModal = false">取消</a-button>
              <a-button @click="handleDelPhoto" type="danger">
                确认
              </a-button>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal :visible="previewVisible" width="800px" centered :footer="null" mask-close-able="false" @cancel="handleCancel">
        <div v-if="previewFile" style="padding:20px;position:relative">
          <img v-if="previewFile.type == 'pic' || previewFile.type === null" alt="example" style="max-width:100%;max-height:82vh;margin: auto;display: block;" :src="clearUrl(previewFile.img_url)" />
          <video
            v-if="previewFile.type == 'video'"
            style="width: 100%;object-fit: fill;"
            :src="clearUrl(previewFile.img_url)"
            controls
          ></video>
          <audio
            style="width: 100%;object-fit: fill;"
            v-if="previewFile.type == 'record'"
            :src="clearUrl(previewFile.img_url)"
            controls
          ></audio>
          <!-- <div style="width: 752px;height:752px;background-size: contain;background-position: center center;background-repeat: no-repeat;" :style="{backgroundImage:'url(' + previewImage+ ')'}"></div> -->
          <a-icon @click.stop="handleLeft" class="arrow-left" :class="leftStatus" type="left-circle" />
          <a-icon @click.stop="handleRight" class="arrow-right" :class="rightStatus" type="right-circle" />
        </div>
      </a-modal>
      <a-modal
        :visible="uploadModal"
        centered
        :title="albumName + '-添加照片'"
        width="1180px"
        footer=""
        @cancel="uploadModal = false"
      >
        <div class="photos">
          
          <a-upload-dragger
            name="file"
            list-type="picture-card"
            :multiple="true"
            :file-list="fileList"
            :data="{related_path: 'album'}"
            accept=".png,.jpg,.jpeg,.gif,.bmp"
            :action="$api.domain + $api.addPhoto"
            :before-upload="beforeUploadFile"
            @preview="handlePreview"
            @change="handleChange"
            :transform-file="transformFile"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              点击或者拖拽图片到此处
            </p>
            
          </a-upload-dragger>
          <div style="font-size: 12px;color:#999;flex:1;text-align:left">请确认您上传的照片后缀名是否为常见的图片格式，如JPEG, JPG，PNG;如果不是，请通过图片工具进行转换后上传</div>
          <div v-if="errorUploadState" style="text-align:right">
            
            <a-space>
              <a-button @click="cancelUpload">
                取消添加
              </a-button>
              <a-button @click="confirmUpload" type="primary">
                忽略并添加相册
              </a-button>
            </a-space>
            
          </div>
        </div>
      </a-modal>
      <a-modal
        :visible="disModal"
        centered
        :title="'分配照片'"
        width="1200px"
        ok-text="确认"
        cancel-text="取消"
        @ok="handleDis"
        @cancel="cancelDisModel"
      >
        <div class="photos">
          <div class="dis-list">
            <div v-for="(item, index) in disList" :key="index" class="dis-cell">
              <img class="dis-photo" :src="item.img_url" alt="" />
              <div v-if="item && item.is_sb && !item.binding" class="tip">已识</div>
              <div v-if="item && item.binding" class="bind">分配</div>
            </div>
          </div>
          <div class="section">
            <div class="head">
              <div class="name">学生列表：</div>
              <div @click="handleAllDis" class="alldis">全部分配</div>
              <div @click="handleRemoveStudent" class="allRemove">全部移除</div>
            </div>
            <div class="student-list">
              <div
                @click="selectStudent(index)"
                v-for="(item, index) in studentList"
                :key="index"
                class="student-cell"
                :class="item.select ? 'select' : ''"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal
        :visible="singleModal"
        centered
        :title="'单图分配'"
        width="1200px"
        ok-text="确认"
        cancel-text="取消"
        @ok="handleDisSingle"
        @cancel="singleModal = false"
      >
        <div class="photos">
          <div v-if="currentIndex > -1" class="dis-list">
            <div class="dis-cell">
              <img class="dis-photo" :src="photoList[timeList[currentTimeindex]][currentIndex].img_url" alt="" />
            </div>
          </div>
          <div class="section">
            <div class="head">
              <div class="name">学生列表：</div>
              <div @click="handleAllDis" class="alldis">全部分配</div>
              <div @click="handleRemoveStudent" class="allRemove">全部移除</div>
            </div>
            <div class="student-list">
              <div
                @click="selectStudent(index)"
                v-for="(item, index) in studentList"
                :key="index"
                class="student-cell"
                :class="item.select ? 'select' : ''"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal  v-model="showUploadTip"
      title="温馨提示"
      :closable="false"
      centered
      :cancelButtonProps = "{style:{display:'none'}}"
      @ok="handleOkUpload">
        <p>1、请不要使用逆光、弱光环境下拍摄的照片</p> 
        <p>2、请不要上传20M以上的照片</p>
        <p>3、请不要上传色情、涉政等违规图片</p>
        <p>4、因为照片质量较差，会影响印刷质量(发暗和模糊)，建议慎用</p>
        <p>5、为了照片的完整性，照片的四周5mm内不要 留有重要信息哦，小心被裁掉</p>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Cookies from 'js-cookie'
import { compressImageIfNeeded } from "../js/imageCom";
// import BetterScroll from "better-scroll";
import { checkFileFormat } from "@/utils/validate";

import _ from "lodash";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  data() {
    return {
      previewFile:null,
      previewIndex: [],
      photoList: null,
      photoNum:0,
      singleModal: false,
      currentPhoto: null,
      currentIndex: -1,
      rightContentLeft: 0,
      rightContentTop: 0,
      showRight: false,
      photoName: "",
      editModal: false,
      delModal: false,
      backimg1: require("../assets/doc.png"),
      backimg2: require("../assets/doc-01.png"),
      studentList: [],
      id: "",
      albumName: "",
      uploadModal: false,
      previewVisible: false,
      fileList: [],
      type: "全部照片",
      disList: [],
      disModal: false,
      rightStyle: {
        left: 0,
        top: 0,
      },
      timeList: [],
      errorUploadState:false,
      currentTimeindex: 0,
      showUploadTip:false,
      leftStatus: '',
      rightStatus: '',
      img_type: ""
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.scroll = new BetterScroll(this.$refs.scroll, {
    //     scrollY: true,
    //     scrollbar: true,
    //     mouseWheel: {
    //       speed: 20,
    //       invert: false,
    //       easeTime: 300,
    //     },
    //   });
    // });
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  created() {
    if(!Cookies.get('uploadTip')) {
      this.showUploadTip  = true
    }
    this.id = this.$route.params.id;
    this.albumName = this.$route.query.name;
    if (this.userInfo) {
      this.getPhoto();
      this.getStudent();
    }
  },
  filters: {
    filterIndex(index) {
      if (index < 9) {
        return "0" + (index + 1);
      } else {
        return index + 1;
      }
    },
  },
  watch: {
    userInfo(val) {
      if (val) {
        this.getPhoto();
        this.getStudent();
      }
    },
  },
  methods: {
    beforeUpload(file) {
      const { valid, message } = checkFileFormat(file);
      if (!valid) {
        this.$message.warning(message);
        return false;
      }
      return true;
    },
    transformFile(file) {
      return compressImageIfNeeded(file)
    },
    handleLeft() {
      this.leftStatus = 'click'
      const timer = setTimeout(() => {
        this.leftStatus = ''
      }, 200);
      if (this.previewIndex[1] > 0) {
        this.previewIndex[1]--
        this.rightStatus = ''
      } else {
        if(this.previewIndex[0] > 0) {
          this.previewIndex[0]--
          this.previewIndex[1] = this.photoList[this.timeList[this.previewIndex[0]]].length - 1
          this.rightStatus = ''
        } else {
          this.$message.info('已经到顶部了')
          this.leftStatus = 'none'
          clearTimeout(timer)
        }
      }
      this.previewFile = this.photoList[this.timeList[this.previewIndex[0]]][this.previewIndex[1]]
    },
    handleRight() {
      this.rightStatus = 'click'
      const timer = setTimeout(() => {
        this.rightStatus = ''
      }, 200);
      if (this.previewIndex[1] < this.photoList[this.timeList[this.previewIndex[0]]].length - 1) {
        this.previewIndex[1]++
        this.leftStatus = ''
      } else {
        if(this.previewIndex[0] < this.timeList.length - 1) {
          this.previewIndex[1] = 0
          this.previewIndex[0]++
          this.leftStatus = ''
        } else {
          this.$message.info('没有更多照片了')
          this.rightStatus = 'none'
          clearTimeout(timer)
        }
      }
      this.previewFile = this.photoList[this.timeList[this.previewIndex[0]]][this.previewIndex[1]]
    },
    handleOkUpload() {
      Cookies.set('uploadTip',true)
      this.showUploadTip = false
    },
    beforeUploadFile (f, l) {
      const { valid, message } = checkFileFormat(f);
      if (!valid) {
        this.$message.warning(message);
        return false;
      }
      return true;
      // if(!isLt50M) {
      //   this.$message.error(f.name + '照片需大于1.5M，才可高清预览')
      //   return false
      // } else {
      //   return true
      // }
    },
    clearUrl(url) {
      if(!url) {
        url = ''
      } else if (url.indexOf('?')) {
        url = url.split('?')[0]
      } 
      return url
    },
    showBigPic(file,index,timeIndex) {
      this.previewIndex = [timeIndex,index]
      this.previewFile = file
      this.previewFile.url = this.clearUrl(this.previewFile.img_url)
      this.previewVisible = true
    },
    handleDisSingle() {
      var student_ids = [];
      this.studentList.map((arr) => {
        if (arr.select) {
          student_ids.push(arr.id);
        }
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.disOnes,
        headers: { Authorization: this.$store.state.headers },
        data: {
          album_img_id: this.photoList[this.timeList[this.currentTimeindex]][this.currentIndex].id,
          student_id: student_ids.join(","),
        },
      })
        .then((res) => {
          this.$message.info(res.data.msg);
          if (res.data.status == 200) {
            this.getPhoto();
            this.singleModal = false
          }
        })
        .catch(() => {
          this.$message.error("网络或服务器未知错误");
        });
    },
    showSingleModal(index,timeIndex) {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.img_info,
          headers: { Authorization: this.$store.state.headers },
          data: { album_id: this.photoList[this.timeList[timeIndex]][index].id },
        })
          .then((res) => {
            if (res.data.status == 200) {
              if (res.data.data.binding && res.data.data.binding !== {}) {
                this.studentList = this.studentList.map(arr=>{
                  arr.select = false
                  return arr
                })
                for (const id in res.data.data.binding) {
                  this.studentList.forEach((arr) => {
                    if (arr.id == id) {
                      arr.select = true 
                    } 
                    return arr
                  });
                }
                this.currentIndex = index
                this.currentTimeindex = timeIndex
                this.singleModal = true 
              }
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
    },
    handleRemoveStudent() {
      this.studentList = this.studentList.map((arr) => {
        arr.select = false;
        return arr;
      });
    },
    delStudentBind(id, photoId) {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.unbindPhoto,
        headers: { Authorization: this.$store.state.headers },
        data: { student_id: id, album_img_ids: photoId },
      })
        .then((res) => {
          this.$message.info(res.data.msg);
          if (res.data.status == 200) {
            this.getPhoto();
          }
        })
        .catch(() => {
          this.$message.error("网络或服务器未知错误");
        });
    },
    cancelDisModel() {
      this.studentList = this.studentList.map((arr) => {
        arr.select = false;
        return arr;
      });
      this.disModal = false;
    },
    handleAllDis() {
      this.studentList = this.studentList.map((arr) => {
        arr.select = true;
        return arr;
      });
    },
    selectStudent(index) {
      this.studentList[index].select = !this.studentList[index].select;
      this.$forceUpdate();
    },
    handleReDis(index) {
      var student_ids = [];
      this.studentList.map((arr) => {
        if (arr.select) {
          student_ids.push(arr.id);
        }
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.disOnes,
        headers: { Authorization: this.$store.state.headers },
        data: {
          album_img_id: this.photoList[index].id,
          student_id: student_ids.join(","),
        },
      })
        .then((res) => {
          this.$message.info(res.data.msg);
          if (res.data.status == 200) {
            this.getPhoto();
            this.disModal = false;
            this.studentList.map(arr=>{
              arr.select = false
              return arr
            })
          }
        })
        .catch(() => {
          this.$message.error("网络或服务器未知错误");
        });
    },
    showDisModel() {
      this.studentList = this.studentList.map(arr=>{
        arr.select = false
        return arr
      })
      var disList = [];
      var sbList = [];
      var select = []
      var timeIndex = 0
      for (const time in this.photoList) {
        this.photoList[time].map((arr,index) => {
          if (arr.select) {
            select.push({...arr,index:index,timeIndex})
          }
          if (arr.select && !arr.is_sb && !arr.binding) {
            disList.push(arr);
          }
          if (arr.select && arr.is_sb && !arr.binding) {
            sbList.push(arr);
          }
        });
        timeIndex++
      }
      if (select.length == 1) {
        //如何通过键名找到是对象的第几个
        this.showSingleModal(select[0].index,select[0].timeIndex)
        return
      }
      if (disList.length > 0) {
        this.disModal = true;
        this.disList = disList;
      } else if (sbList.length > 0) {
        this.disModal = true;
        this.disList = sbList;
      } else {
        this.$message.error("选择的图片已分配，点击更多单图分配");
      }
      this.disList = this.disList.map((arr) => {
        arr.select = false;
        return { ...arr };
      });
      if (this.disList.length == 1) {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.img_info,
          headers: { Authorization: this.$store.state.headers },
          data: { album_id: this.disList[0].id },
        })
          .then((res) => {
            if (res.data.status == 200) {
              // if (res.data.data.binding !== {} && res.data.data.binding) {
              //   var ids = Object.keys(res.data.data.binding);
              //   ids.forEach((id) => {
              //     console.log(id);
              //     this.studentList.forEach((student, index) => {
              //       if (student.id == id) {
              //         this.studentList[index].select = true;
              //         this.$forceUpdate();
              //       }
              //     });
              //   });
              //   return false;
              // }
              console.log(res.data.data.sb)
              if (res.data.data.sb && res.data.data.sb !== {}) {
                console.log('1')
                console.log(Object.keys(res.data.data.sb)[0])
                this.disList[0].sb = Object.keys(res.data.data.sb)[0];
                this.studentList.forEach((arr, index) => {
                  if (arr.id == Object.keys(res.data.data.sb)[0]) {
                    this.studentList[index].select = true;
                  }
                });
                this.$forceUpdate()
              }
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      }
    },
    handleDis() {
      var img_ids = [];
      var student_ids = [];
      this.studentList.map((arr) => {
        if (arr.select) {
          student_ids.push(arr.id);
        }
      });
      this.disList.map((arr) => {
        img_ids.push(arr.id);
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.dis_all,
        headers: { Authorization: this.$store.state.headers },
        data: {
          album_img_id: img_ids.join(","),
          student_id: student_ids.join(","),
        },
      })
        .then((res) => {
          this.$message.info(res.data.msg);
          if (res.data.status == 200) {
            this.getPhoto();
            this.disModal = false;
            this.studentList = this.studentList.map((arr) => {
              arr.select = false;
              return arr;
            });
          }
        })
        .catch(() => {
          this.$message.error("网络或服务器未知错误");
        });
    },
    changeType() {
      this.getPhoto();
    },
    changeType2() {
      this.getPhoto();
    },
    beforeUpload(file) {
      const isBig = file.size / 1024 / 1024 > 1.5;
      return true
      if (!isBig) {
        this.$message.error('照片不得小于1.5MB!');
      }
      return isBig;
    },
    //上传代码
    handleUpload() {
      if (this.uploadState) return false;
      var img_url = [];
      var errors = []
      var state = true;
      console.log(this.fileList)
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].status == 'done' && this.fileList[i].response && this.fileList[i].response.data) {
            img_url.push(this.fileList[i].response.data.url);
        } else if (this.fileList[i].status == 'uploading') {
          state = false;
          break;
        } else if (this.fileList[i].status == 'error' || this.fileList[i].response != 200) {
          errors.push(i+1)
          this.errorUploadState = true
          state = false
        } 
      }
      console.log(img_url)
      if (!state) return false;
      console.log(errors)
      if (errors.length > 0) {
        this.$message.error(`第${errors.join(',')}文件上传失败`)
      }
      if (img_url.length == 0) {
        this.uploadState = false;
        this.fileList = [];
        this.uploadModal = false;
        return false
      }
      this.uploadState = true;
      this.$message.loading({
        content: "Loading...",
        key: "uploadState",
        duration: 10,
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.albumAdd,
        headers: { Authorization: this.$store.state.headers },
        data: { album_id: this.id, img_url: img_url.join(",") },
        timeout:10000
      })
        .then((res) => {
          this.uploadState = false;
          this.fileList = [];
          setTimeout(() => {
            this.$message.info({
              content: res.data.msg,
              key: "uploadState",
              duration: 2,
            });
          }, 1000);
          if (res.data.status == 200) {
            this.uploadModal = false;
            this.getPhoto();
          } else if (res.data.status == 204) {
            this.uploadModal = false;
            this.getPhoto();
          }
        })
        .catch(() => {
          this.uploadState = false;
          this.$message.error("网络或服务器未知错误");
        });
    },

    cancelUpload() {
      this.uploadModal = false 
      this.fileList = []
      this.errorUploadState = false
    },
    confirmUpload() {
      if (this.uploadState) return false;
      var img_url = [];
      var errors = []
      var state = true;
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].status == 'done' && this.fileList[i].response && this.fileList[i].response.data) {
            img_url.push(this.fileList[i].response.data.url);
        }
      }
      if (img_url.length == 0) {
        this.uploadState = false;
        this.fileList = [];
        this.uploadModal = false;
        return false
      }
      this.uploadState = true;
      this.$message.loading({
        content: "Loading...",
        key: "uploadState",
        duration: 10,
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.albumAdd,
        headers: { Authorization: this.$store.state.headers },
        data: { album_id: this.id, img_url: img_url.join(",") },
        timeout:10000
      })
        .then((res) => {
          this.uploadState = false;
          this.fileList = [];
          setTimeout(() => {
            this.$message.info({
              content: res.data.msg,
              key: "uploadState",
              duration: 2,
            });
          }, 1000);
          if (res.data.status == 200) {
            this.uploadModal = false;
            this.getPhoto();
          }
        })
        .catch(() => {
          this.uploadState = false;
          this.$message.error("网络或服务器未知错误");
        });
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
      this.handleUpload();
    },
    handleCancel() {
      this.previewFile = null
      this.previewVisible = false;
    },
    getStudent() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.studentList,
        headers: { Authorization: this.$store.state.headers },
      })
        .then((res) => {
          this.studentList = res.data.data.rows;
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    selectPhoto($event, index, timeIndex) {
      if (this.currentIndex < 0) {
        this.photoList[this.timeList[timeIndex]][index].select = true;
        this.currentIndex = index;
        this.currentTimeindex = timeIndex;
        this.$forceUpdate();
        return false;
      }
      if ($event.shiftKey) {
        for (const time in this.photoList) {
          console.log(time);
          var max = _.max([
            this.photoList[this.timeList[this.currentTimeindex]][
              this.currentIndex
            ].order,
            this.photoList[this.timeList[timeIndex]][index].order,
          ]);
          var min = _.min([
            this.photoList[this.timeList[this.currentTimeindex]][
              this.currentIndex
            ].order,
            this.photoList[this.timeList[timeIndex]][index].order,
          ]);
          this.photoList[time] = this.photoList[time].map((arr) => {
            arr.select = false;
            if (arr.order <= max && arr.order >= min) {
              arr.select = true;
            }
            return arr;
          });
        }
        this.$forceUpdate();
        this.currentIndex = index;
        this.currentTimeindex = timeIndex;
        return false;
      }
      if ($event.ctrlKey) {
        this.photoList[this.timeList[timeIndex]][index].select = !this
          .photoList[this.timeList[timeIndex]][index].select;
        this.$forceUpdate();
        this.currentIndex = index;
        this.currentTimeindex = timeIndex;
        return false;
      }
      if (!$event.shiftKey && !$event.ctrlKey) {
        for (const time in this.photoList) {
          this.photoList[time] = this.photoList[time].map((arr) => {
            arr.select = false;
            return arr;
          });
        }
        this.photoList[this.timeList[timeIndex]][index].select = true;
        this.currentIndex = index;
        this.currentTimeindex = timeIndex;
      }
    },
    editPhoto(index) {
      this.currentPhoto = _.cloneDeep(this.photoList[index]);
      this.editModal = true;
    },
    handleSelectAll() {
      for (const time in this.photoList) {
        this.photoList[time] = this.photoList[time].map((arr) => {
          arr.select = true;
          return arr;
        });
      }
      this.$forceUpdate();
    },
    handleEditPhoto() {
      if (!this.currentPhoto) {
        this.$message.error("未填写任何姓名");
      } else {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.editPhoto,
          headers: { Authorization: this.$store.state.headers },
          data: { id: this.currentPhoto.id, name: this.currentPhoto.name },
        })
          .then((res) => {
            this.studentName = "";
            this.$message.info(res.data.msg);
            if (res.data.status == 200) {
              this.editModal = false;
              this.getPhoto();
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      }
    },
    handleDelPhoto() {
      var ids = [];
      console.log(this.photoList)
      for (const time in this.photoList) {
        console.log(time)
        this.photoList[time] = this.photoList[time].map((arr) => {
          if (arr && arr.select) {
            ids.push(arr.id);
          }
        });
      }
      if (ids.length > 0) {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.delPhoto,
          headers: { Authorization: this.$store.state.headers },
          data: { album_img_id: ids.join(","), album_id: this.id },
        })
          .then((res) => {
            this.$message.info(res.data.msg);
            if (res.data.status == 200) {
              this.delModal = false;
              this.photoList = []
              this.getPhoto();
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      } else {
        this.$message.error("未选择任何相册");
      }
    },
    contentRight(e) {
      var clientWidth = document.body.clientWidth;
      var clientHeight = document.body.clientHeight;
      this.rightContentLeft =
        clientWidth - e.pageX < 120 ? e.pageX - 120 : e.pageX;
      if (clientHeight - e.pageY < 130) {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
          transform: "translateY(-100%)",
        };
      } else {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
        };
      }
      this.showRight = true;
      for (const time in this.photoList) {
        this.photoList[time] = this.photoList[time].map((arr) => {
          arr.select = false;
          return arr;
        });
      }
      console.log(e);
    },
    cancelContent() {
      this.showRight = false;
    },
    photoRight(e, index, timeIndex) {
      console.log(timeIndex);
      e.stopPropagation();
      var clientWidth = document.body.clientWidth;
      var clientHeight = document.body.clientHeight;
      this.rightContentLeft =
        clientWidth - e.pageX < 120 ? e.pageX - 120 : e.pageX;
      if (clientHeight - e.pageY < 100) {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
          transform: "translateY(-100%)",
        };
      } else {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
        };
      }
      this.showRight = true;
      this.currentPhoto = _.cloneDeep(
        this.photoList[this.timeList[timeIndex]][index]
      );
      if (!this.photoList[this.timeList[timeIndex]][index].select) {
        for (const time in this.photoList) {
          this.photoList[time] = this.photoList[time].map((arr) => {
            arr.select = false;
            return arr;
          });
        }
        this.photoList[this.timeList[timeIndex]][index].select = true;
      }
      this.$forceUpdate();
      this.currentIndex = index;
      this.currentTimeindex = timeIndex;
    },
    getPhoto() {
      this.currentIndex = -1
      this.currentTimeindex = 0
      this.$message.loading({content:'加载中',key:"load"})
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.albumTime,
        headers: { Authorization: this.$store.state.headers },
        data: {
          album_id: this.id,
          type: this.type == "全部照片" ? 0 : this.type,
          img_type: this.img_type ? this.img_type : undefined
        },
      })
        .then((res) => {
          this.$message.success({content:'加载完成',key:"load"})
          if (res.data.status == 200 && res.data.data && JSON.stringify(res.data.data)  != '[]') {
            this.photoList = res.data.data;
            this.timeList = Object.keys(res.data.data);
            var order = 0;
            for (const time in this.photoList) {
              console.log(time);
              this.photoList[time] = this.photoList[time].map((arr) => {
                console.log(arr)
                arr.order = order;
                arr.select = false;
                arr.img_url += '?x-image-process=image/resize,w_200/quality,Q_80'
                order++;
                return {...arr};
              });
            }
            this.photoNum = order
            console.log(this.photoList);
            // this.photoList = res.data.data.map((arr) => {
            //   arr.select = false;
            //   return arr;
            // });
          } else  {
            this.$message.error({content:res.data.msg == '操作成功' ? '暂无照片' : res.data.msg,key:"load"})
            this.photoList = null
          }
          // this.$nextTick(() => {
          //   this.scroll = new BetterScroll(this.$refs.scroll, {
          //     scrollY: true,
          //     scrollbar: true,
          //     mouseWheel: {
          //       speed: 20,
          //       invert: false,
          //       easeTime: 300,
          //     },
          //   });
          // });
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("服务器或网络错误");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.student-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  flex-wrap: wrap;
  .student-cell {
    cursor: pointer;
    margin-bottom: 30px;
  }
  .tx {
    width: 60px;
    height: 60px;
    border-radius: 60px;
    margin-right: 30px;
  }
  .name {
    width: 60px;
    text-align: center;
    color: #888;
    margin-top: 10px;
    font-size: 14px;
  }
}
.scroll {
  position: absolute;
  left: -20px;
  right: -20px;
  padding-left: 20px;
  top: 0;
  bottom: 0;
  overflow: hidden;
  box-sizing: border-box;
  .scroll-wrapper {
    height: 100%;
    overflow-y: scroll;
    padding-right: 20px;
    box-sizing: border-box;
  }
}
.head-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  .left {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .main {
      font-size: 16px;
    }
  }
  .right {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .msg {
      display: flex;
      flex-direction: row;
      align-items: center;
      .txt {
        margin-right: 3px;
      }
    }
  }
}
.time {
  color: rgb(133, 166, 216);
  font-size: 20px;
  margin-top: 20px;
}
.frame-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 10px;
  
  .addframe {
    width: 175px;
    margin-bottom: 80px;
    margin-right: 30px;
    cursor: pointer;
  }
  .addbox {
    width: 250px;
    height: 130px;
    border-radius: 0 20px 0 20px;

    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 3px dashed #67b0dc;
    cursor: pointer;
    .add {
      font-size: 40px;
    }
    .addtip {
      font-size: 20px;
      color: #67b0dc;
      margin-bottom: 16px;
    }
  }

  .cell {
    width: 175px;
    height: 143px;
    margin-bottom: 65px;
    box-sizing: border-box;
    margin-right: 30px;
    position: relative;
    // overflow: hidden;
    background-size: contain;
    background-position: center;
    background-color: #eee;
    background-repeat: no-repeat;
    .photo {
      height: 143px;
      width: 100%;
      background: #efefef;
      // position: absolute;
      // left: 50%;
      // top: 50%;
      // transform: translate(-50%,-50%);
    }
    .tip {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #67b0dc;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    .bind {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #df815c;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    &.select {
      border: 2px solid #67b0dc;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        height: 143px;
        background: rgba($color: #000000, $alpha: 0.3);
      }
    }
    .msg {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .top {
        cursor: pointer;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #fff;
        font-size: 18px;
        img {
          width: 20px;
          margin-left: 10px;
        }
      }
      .foot {
        font-size: 14px;
        color: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        .order {
          font-size: 30px;
          line-height: 1;
        }
      }
    }
  }
}
.frame-list .unselect {
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -ms-user-select: none;
}
::-webkit-scrollbar-track-piece {
  background-color: #f1f1f1;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #a8b3bb;
  background-clip: padding-box;
  min-height: 28px;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}
.head-title .left .name {
  font-size: 12px;
}
.head-title .left .icon {
  margin: 0 6px;
}
::v-deep .ant-select-selection-selected-value {
  font-size: 12px;
}
::v-deep .ant-upload.ant-upload-drag {
  margin-bottom: 8px;
}
::v-deep .ant-upload-list {
  overflow: hidden;
}
.dis-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  .dis-cell {
    width: 175px;
    height: 143px;
    margin-bottom: 10px;
    box-sizing: border-box;
    margin-right: 10px;
    position: relative;
    .dis-photo {
      width: 100%;
      height: 100%;
    }
    .tip {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #67b0dc;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    .bind {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #df815c;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    &.select {
      border: 3px solid #67b0dc;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba($color: #000000, $alpha: 0.3);
      }
    }
  }
}
.section {
  width: 100%;
  margin-top: 5px;
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .name {
      color: #67b0dc;
      margin-right: 6px;
    }
    .alldis {
      background: #67b0dc;
      color: #fff;
      font-size: 12px;
      border-radius: 100px;
      padding: 4px 10px;
      cursor: pointer;
    }
  }
  .allRemove {
    background: #e76969;
    margin-left: 10px;
    color: #fff;
    font-size: 12px;
    border-radius: 100px;
    padding: 4px 10px;
    cursor: pointer;
  }
  .student-list {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .student-cell {
      padding: 4px 10px;
      width: 80px;
      border-radius: 20px;
      margin-bottom: 8px;
      background: #f1f1f1;
      border: 1px solid #eee;
      color: #898989;
      margin-right: 10px;
      text-align: center;
      cursor: pointer;

      &.select {
        background: #67b0dc;
        color: #fff;
      }
    }
  }
}
.fp {
  background: #fff;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  height: 58px;
  padding: 2px 0;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 100%;
  right: 0;
  .fp-cell {
    width: 53px;
    cursor: pointer;
    height: 23px;
    line-height: 23px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: #eee;
    border: 1px solid #eee;
    margin: 2px;
    font-size: 12px;
    .name {
      color: #898989;
      margin-right: 3px;
    }
  }
}

.arrow-left {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-580px, -50%);
  cursor: pointer;
  z-index: 10;
  font-size: 50px;
  color: #fff;
  &.click {
    opacity: 0.5;
  }
  &.none {
    opacity: 0.3;
  }
}

.arrow-right {
  position: fixed;
  right: 50%;
  top: 50%;
  transform: translate(580px,-50%);
  cursor: pointer;
  z-index: 10;
  font-size: 50px;
  color: #fff;
  &.click {
    opacity: 0.5;
  }
  &.none {
    opacity: 0.3;
  }
}
</style>
